// WP-1.20 (S-39..46): the Settings shell — a left subnav + the active section.
import { NavLink, Outlet } from 'react-router-dom';

const SECTIONS = [
  { to: 'financial', label: 'Financial' },
  { to: 'categories', label: 'Categories & Tags' },
  { to: 'ai', label: 'AI' }, // WP-2.8 (CA-6, OB-1)
  { to: 'whatsapp', label: 'WhatsApp' }, // WP-2.1 (S-42/43)
  { to: 'calendars', label: 'Calendars' }, // WP-C1.1 (INT-1/2/4)
  { to: 'notifications', label: 'Notifications' }, // NT-2
  { to: 'security', label: 'Security' },
  { to: 'backups', label: 'Backups' },
  { to: 'about', label: 'About' },
];

export function SettingsLayout(): React.JSX.Element {
  return (
    <div>
      <h1 className="mb-4 text-xl font-semibold text-ink">Settings</h1>
      <div className="flex flex-col gap-6 md:flex-row">
        <nav
          className="flex shrink-0 gap-1 overflow-x-auto md:w-48 md:flex-col"
          aria-label="Settings sections"
        >
          {SECTIONS.map((s) => (
            <NavLink
              key={s.to}
              to={s.to}
              className={({ isActive }) =>
                `rounded-[var(--radius-control)] px-3 py-2 text-sm ${
                  isActive ? 'bg-primary/10 font-medium text-primary' : 'text-ink hover:bg-bg'
                }`
              }
            >
              {s.label}
            </NavLink>
          ))}
        </nav>
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
